// extracted by mini-css-extract-plugin
module.exports = {"bundle-item":"ProductItem_bundle-item___Xe0M","single":"ProductItem_single___pSvA"};